<template>
  <div class="past">
    <div class="circle" style="--i: 1">
      <img src="../assets/images/past/01.png" />
      <div class="photo">
        <img src="../assets/images/past/pic01.png" />
        <img src="../assets/images/past/pic02.png" />
      </div>
    </div>
    <div class="circle" style="--i: 2">
      <img src="../assets/images/past/02.png" />
      <div class="photo">
        <img src="../assets/images/past/pic03.png" />
        <img src="../assets/images/past/pic04.png" />
      </div>
    </div>
    <div class="circle" style="--i: 3">
      <img src="../assets/images/past/03.png" />
      <div class="photo">
        <img src="../assets/images/past/clock01.png" />
        <img src="../assets/images/past/clock02.png" />
      </div>
    </div>
    <div class="circle" style="--i: 4">
      <img src="../assets/images/past/04.png" />
      <div class="photo">
        <img src="../assets/images/past/pic05.png" />
        <img src="../assets/images/past/pic06.png" />
      </div>
    </div>
    <div class="circle" style="--i: 5">
      <img src="../assets/images/past/01.png" />
      <div class="photo">
        <img src="../assets/images/past/pic07.png" />
        <img src="../assets/images/past/pic08.png" />
      </div>
    </div>
    <div class="circle" style="--i: 6">
      <img src="../assets/images/past/02.png" />
      <div class="photo">
        <img src="../assets/images/past/clock01.png" />
        <img src="../assets/images/past/clock02.png" />
      </div>
    </div>
    <div class="circle" style="--i: 7">
      <img src="../assets/images/past/03.png" />
      <div class="photo">
        <img src="../assets/images/past/pic11.png" />
        <img src="../assets/images/past/pic12.png" />
      </div>
    </div>
    <div class="circle" style="--i: 8" ref="messageShow">
      <img src="../assets/images/past/04.png" />
      <div class="photo">
        <img src="../assets/images/past/clock03.png" />
        <img src="../assets/images/past/clock04.png" />
      </div>
    </div>
    <div class="circle" style="--i: 9">
      <img src="../assets/images/past/01.png" />
      <div class="photo">
        <img src="../assets/images/past/pic13.png" />
        <img src="../assets/images/past/pic14.png" />
      </div>
    </div>
    <div class="clock">
      <img src="../assets/images/past/05.png" />
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  emits: ['pageChange'],
  setup(props, { emit }) {
    const messageShow = ref(null)

    onMounted(() => {
      messageShow.value.addEventListener('animationend', function () {
        emit('pageChange', 'Message')
      })
    })

    return {
      messageShow
    }
  }
}
</script>

<style scoped>
.past {
  overflow: hidden;

  width: 100%;
  height: 100%;

  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  /* 视距:距离屏幕的距离 */
  perspective: 100px;

  transition: all 0.5s ease-in-out;
}

.past .circle {
  width: 50%;
  position: absolute;

  opacity: 0;

  animation: circle 5s linear forwards;
  animation-delay: calc(var(--i) * 0.5s);

  z-index: 10;
}

.past .circle .photo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.past .circle:nth-child(2n + 1) .photo {
  flex-direction: row;
}

.past .circle .photo img {
  width: 20%;
  height: auto;
  border: 5px solid #fff;
  box-shadow: 3px 3px 3px #eee;
  border-radius: 5px;
}

/* 时钟取消边框和阴影 */
.past .circle:nth-child(3) .photo img,
.past .circle:nth-child(6) .photo img,
.past .circle:nth-child(8) .photo img {
  border: 0px;
  box-shadow: none;
}

.past .clock {
  z-index: 6;
  width: 20%;
  /* opacity: 1; */
  /* animation: clock 4s linear forwards, clockRotate 4s linear 4s infinite; */
  animation: clockRotate 4s linear infinite;
}

@keyframes circle {
  0% {
    opacity: 0;
    transform: translateZ(0px) scale(0.1);
  }
  100% {
    opacity: 1;
    transform: translateZ(100px) scale(1);
  }
}

/* @keyframes clock {
  0% {
    opacity: 0;
    transform: rotate(0deg) scale(0);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg) scale(1);
  }
} */
@keyframes clockRotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}

/* 响应式 */
/* 超小屏幕(手机，<768px) */
@media screen and (max-width: 767px) {
  .past .circle {
    width: 85%;
  }
  .past .clock {
    width: 40%;
  }
}
/* 小屏幕(平板，≥768px)*/
@media screen and (min-width: 768px) {
  .past .circle {
    width: 80%;
  }
  .past .clock {
    width: 40%;
  }
}
/* 中等屏幕(桌面显示器，≥992px */
@media screen and (min-width: 992px) {
  .past .circle {
    width: 50%;
  }
  .past .clock {
    width: 25%;
  }
}
/* 大屏幕(大桌面显示器，≥1200x) */
@media screen and (min-width: 1200px) {
}
</style>
